import Switch from './switch';

export default Switch;
export type * from './types';
